'use client';

import { cn } from '@/lib/utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

const Label = ({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>): React.JSX.Element => {
  return (
    <LabelPrimitive.Root className={cn(
      'flex items-center gap-2 text-sm leading-none select-none group-data-[disabled=true]:pointer-events-none',
      'group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
      className
    )}
    data-slot="label"
    {...props}
    />
  );
};

export { Label };
